import { Link, useParams } from "react-router";
import { useNotes } from "../../hooks";

export default function NoteDetail() {
  const { id } = useParams<string>();
  const { getNoteById } = useNotes();

  const note = getNoteById(id || "");

  return (
    <div className="flex flex-col items-start mt-8">
      <Link to={`/notes`} className="text-blue-500 hover:underline mb-8">
        ← Back to Notes list
      </Link>
      {note ? (
        <>
          <h2 className="text-2xl font-bold mb-4">{note.title}</h2>
          <p>{note.description}</p>
        </>
      ) : (
        <p>Note not found.</p>
      )}
    </div>
  );
}
